import AccessibilityHelper from '../lib/AccessibilityHelper.js';
import getDeviceType from '../lib/getDeviceType.js';
import { toast } from '@finn-no/common-browserbundle';
import el from '@finn-no/create-element';

export default {
    dependencies: ['$element', 'formSubmitService', 'templateservice'],
    callable(ele, submitForm, templateService) {
        const isMobile = getDeviceType() === 'mobile';
        const state = JSON.parse(ele.getAttribute('data-initial-state'));
        state.csrfToken = document.querySelector(
            "meta[name='csrf-token']"
        ).content;

        addExpandHandler();

        function addExpandHandler() {
            const expandButton = ele.querySelector('[data-expand]');
            if (!expandButton) {
                return;
            }
            expandButton.addEventListener('click', event => {
                handleExpandButton();
                event.preventDefault();
            });
        }

        function handleExpandButton() {
            render('minfinn/saved_search_item_edit', state);
            if (!state.isTravelType) {
                const updateFormEle = ele.querySelector('[data-update-form]');
                updateFormEle.addEventListener(
                    'submit',
                    handleUpdateFormSubmit
                );
                const nameInput = updateFormEle.elements.name;
                const submitButton = ele.querySelector("[form='update-form']");

                // Opening the keyboard on mobile is annoying, so just focus the form instead
                if (isMobile) {
                    updateFormEle.focus();
                } else {
                    nameInput.focus();
                    nameInput.selectionStart = nameInput.value.length;
                }

                // IE doesn't support form attributes on form controls, so work around that
                if (!submitButton.form) {
                    submitButton.addEventListener('click', () => {
                        const event = document.createEvent('Event');
                        event.initEvent('submit', true, true);
                        updateFormEle.dispatchEvent(event);
                    });
                }
            }
            const deleteFormEle = ele.querySelector('[data-delete-form]');
            deleteFormEle.addEventListener('submit', handleDeleteFormSubmit);
            const cancelForm = ele.querySelector('[data-cancel-form]');
            cancelForm.addEventListener('submit', handleCancelFormSubmit);
        }

        function handleUpdateFormSubmit(event) {
            if (!state.isTravelType) {
                const target = event.target;
                submitForm(target);
                state.title = target.elements.name.value;
                state.notificationByMail = target.querySelector(
                    "[name='notify'][value='mail']"
                ).checked;
                state.notificationByPush = target.querySelector(
                    "[name='notify'][value='push']"
                ).checked;
                state.notificationByWeb = target.querySelector(
                    "[name='notify'][value='web']"
                ).checked;
                state.enabledNotificationsAsString = getEnabledNotificationsAsString();
            }
            render('minfinn/saved_search_item', state);
            addExpandHandler();
            ele.querySelector('[data-expand]').focus();
            event.preventDefault();
        }

        function handleDeleteFormSubmit(event) {
            if (state.isTravelType) {
                return;
            }
            event.preventDefault();
            submitForm(event.target).then(
                handleDeleteSuccess,
                handleDeleteError
            );
        }

        function handleDeleteSuccess() {
            render('minfinn/saved_search_item_deleted', state);
            const undoFormEle = ele.querySelector('[data-undo-form]');
            undoFormEle.addEventListener('submit', handleUndoFormSubmit);
            AccessibilityHelper.focusFirst(ele);

            const node = el(
                'div',
                null,
                'Søket er slettet!',
                el(
                    'button.blank',
                    { onclick: () => undoDelete(undoFormEle) },
                    'Angre'
                )
            );
            toast({ node });
        }

        function handleDeleteError() {
            toast({
                level: 'error',
                message: 'Noe gikk dessverre galt. Prøv igjen.',
            });
        }

        function undoDelete(target) {
            submitForm(target).then(handleUndoSuccess, handleUndoError);
            const renderState = Object.assign({ inProgress: true }, state);
            render('minfinn/saved_search_item_deleted', renderState);
        }

        function handleCancelFormSubmit(event) {
            render('minfinn/saved_search_item', state);
            addExpandHandler();
            ele.querySelector('[data-expand]').focus();
            event.preventDefault();
        }

        function handleUndoFormSubmit(event) {
            undoDelete(event.target);
            event.preventDefault();
        }

        function handleUndoSuccess({ id }) {
            state.url = state.url.replace(state.id, id);
            state.deleteUrl = state.deleteUrl.replace(state.id, id);
            if (state.editParameters) {
                state.editParameters = state.editParameters.replace(state.id, id); // prettier-ignore
            }
            state.id = id;
            render('minfinn/saved_search_item', state);
            addExpandHandler();
            AccessibilityHelper.focusFirst(ele);
        }

        function handleUndoError() {
            const renderState = Object.assign({ undoError: true }, state);
            render('minfinn/saved_search_item_deleted', renderState);
            const undoFormEle = ele.querySelector('[data-undo-form]');
            undoFormEle.addEventListener('submit', handleUndoFormSubmit);
            AccessibilityHelper.focusFirst(ele);
        }

        function render(templateName, state) {
            ele.innerHTML = templateService.render(templateName, state);
        }

        function getEnabledNotificationsAsString() {
            const notifications = [];
            if (state.notificationByMail) {
                notifications.push('E-post');
            }
            if (state.notificationByPush) {
                notifications.push('Push');
            }
            if (state.notificationByWeb) {
                notifications.push('På FINN.no');
            }
            return notifications.length
                ? notifications.join(', ')
                : 'Ingen varslinger';
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/savedSearchEditor.js